import * as React from 'react';
import { t } from '@toolkit/util/i18n';
import { OptionModel } from '@src/shared/src/models';
import { CustomSelect } from './CustomSelect';

export default (props) => (
  <div>
    <CustomSelect
      {...props}
      className="is--large"
      selectedValue={props.input.value}
      onChange={(selectedOption: OptionModel) => props.input.onChange(selectedOption.value)}
      options={props.options}
      placeholder={props.placeholder ? props.placeholder : t('global.select')}
    />
    {props.meta.touched && props.meta.error && (
      <div className="form-error-message">{props.meta.error}</div>
    )}
  </div>
);
